import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../constants/languages';

const useGetDecimalSeparator = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const getDecimalSeparator = () => {
    const shouldUseCommaAsDecimalSeparator = language !== LANGUAGES.en;
    const preferredDecimalSeparator = shouldUseCommaAsDecimalSeparator
      ? ','
      : '.';

    return {
      preferredDecimalSeparator,
    };
  };

  return { getDecimalSeparator };
};

export default useGetDecimalSeparator;
